import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { isPrerendering } from "../utils/isPrerendering";

/**
 * First paint is always a plain element (matches prerender HTML).
 * After mount in a real browser, upgrades to framer-motion.
 * During prerender capture, the upgrade is skipped (side-effect only).
 */
export default function MotionAfterHydration({
  as = "div",
  children,
  className,
  initial,
  animate,
  exit,
  transition,
  whileInView,
  whileHover,
  viewport,
  ...htmlProps
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isPrerendering()) return;
    setReady(true);
  }, []);

  const StaticTag = as;
  if (!ready) {
    return (
      <StaticTag className={className} {...htmlProps}>
        {children}
      </StaticTag>
    );
  }

  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={initial === undefined ? false : initial}
      animate={animate}
      exit={exit}
      transition={transition}
      whileInView={whileInView}
      whileHover={whileHover}
      viewport={viewport}
      {...htmlProps}
    >
      {children}
    </MotionTag>
  );
}
